export default function postMessageToParent(message: {
  message: string;
  id: string;
  payload?: Record<string, string | number>;
}) {
  if (window.webkit?.messageHandlers?.bridge) {
    window.webkit.messageHandlers.bridge.postMessage(JSON.stringify(message));
  }
  if (window.legitHealthJsObject) {
    window.legitHealthJsObject.postMessage(JSON.stringify(message));
  }
  window.parent.postMessage(message, '*');
}
